module.exports = __webpack_public_path__ + "static/media/docs.8b203c75.svg";